<script setup>
import { computed } from 'vue';
import PostSaleStatusAnnotationForm from './PostSaleStatusAnnotationForm.vue';
import PostSaleStatusBankDocumentationForm from './PostSaleStatusBankDocumentationForm.vue';
import PostSaleStatusDeedForm from './PostSaleStatusDeedForm.vue';
import PostSaleStatusEngineeringForm from './PostSaleStatusEngineeringForm.vue';
import PostSaleStatusItbiForm from './PostSaleStatusItbiForm.vue';
import PostSaleStatusLaudemiumForm from './PostSaleStatusLaudemiumForm.vue';
import PostSaleStatusRegistryForm from './PostSaleStatusRegistryForm.vue';
import PostSaleStatusTaxesForm from './PostSaleStatusTaxesForm.vue';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
  postSaleCaseId: { type: [Number, String], default: '' },
  status: { type: String, required: true },
});

const form = computed(() => props.form);

const updateForm = value => Object.assign(form.value, value);
</script>

<template>
  <div class="grid gap-4">
    <PostSaleStatusTaxesForm
      v-if="status === 'taxas'"
      :catalog="catalog"
      :responsavel-vendedor="form.responsavel_vendedor"
      :responsavel-comprador="form.responsavel_comprador"
      :pendencia-taxa="form.pendencia_taxa"
      @update:responsavel-vendedor="form.responsavel_vendedor = $event"
      @update:responsavel-comprador="form.responsavel_comprador = $event"
      @update:pendencia-taxa="form.pendencia_taxa = $event"
    />

    <PostSaleStatusItbiForm
      v-if="status === 'itbi'"
      :catalog="catalog"
      :responsavel-comprador="form.responsavel_comprador"
      @update:responsavel-comprador="form.responsavel_comprador = $event"
    />

    <PostSaleStatusEngineeringForm
      v-if="status === 'engenharia'"
      :banco="form.banco"
      :catalog="catalog"
      :check-engenharia="form.check_engenharia"
      :data-engenharia="form.data_engenharia"
      :errors="errors"
      :hora-engenharia="form.hora_engenharia"
      @update:banco="form.banco = $event"
      @update:check-engenharia="form.check_engenharia = $event"
      @update:data-engenharia="form.data_engenharia = $event"
      @update:hora-engenharia="form.hora_engenharia = $event"
    />

    <PostSaleStatusBankDocumentationForm
      v-if="status === 'banco_documentacao'"
      :check-banco="form.check_banco"
      @update:check-banco="form.check_banco = $event"
    />

    <PostSaleStatusDeedForm
      v-if="status === 'escritura'"
      :catalog="catalog"
      :post-sale-case-id="postSaleCaseId"
      :value="form"
      @update:value="updateForm"
    />

    <PostSaleStatusRegistryForm
      v-if="status === 'registro'"
      :catalog="catalog"
      :value="form"
      @update:value="updateForm"
    />

    <PostSaleStatusAnnotationForm
      v-if="status === 'averbacao'"
      :catalog="catalog"
      :value="form"
      @update:value="updateForm"
    />

    <PostSaleStatusLaudemiumForm
      v-if="status === 'laudemio'"
      :catalog="catalog"
    />
  </div>
</template>
